
















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class ShippingAddressView extends Vue {
  @Prop() private shippingAddress: any;

  private keys = [
    'name',
    'address1',
    'address2',
    'city',
    'zip',
    'province',
    'country',
    'phone',
  ];
}
